import {
  getAffiliatesUserInfo,
  setUserSettings,
} from 'shared/infrastructure/storage/users'
import { NotificationIds } from 'notifications/domain/NotificationsIds'

export const saveNotificationById = (id, value) => {
  const notifications = JSON.parse(getAffiliatesUserInfo())?.settings
    ?.notifications
  setUserSettings({
    setting: { notifications: { ...notifications, [id]: value } },
  })
}

export const getNotificationById = id => getAllNotifications()?.[id]

export const getAllNotifications = () => {
  const storage = JSON.parse(getAffiliatesUserInfo())
  return storage?.settings?.notifications
}

export const saveAllNotifications = (value = true) => {
  if (!getAllNotifications()) {
    saveNotificationById(NotificationIds.HomeFinancingIndication, value)
    saveNotificationById(NotificationIds.HomeFinancingSimulation, value)
    saveNotificationById(NotificationIds.HomeRefinancingDocuments, value)
    saveNotificationById(NotificationIds.AutoRefinancingDeactiveCreation, value)
  }
}
